import Typography from '@mui/material/Typography';
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import Prompt from '../../../../../Prompt/Prompt';

import {
  TXTCLI_Make_your_first_deposit_to_sta_ELL,
  TXTWCL_Almost_there,
  TXTWCL_Continue,
  TXTWCL_Next_upXX
} from './ProceedToDeposit.messages.json';

const ProceedToDeposit: React.FunctionComponent = () => {
  const siteId = useSelector(select.cms.getSiteId);
  const form = useForm();

  return (
    <Prompt
      noCloseButton
      variant="celebration"
      title={{ translation: TXTWCL_Almost_there }}
      secondaryTitle={{ translation: TXTWCL_Next_upXX }}
      primaryButton={{
        translation: TXTWCL_Continue
      }}
      onPrimaryButtonClick={siteId === Sites.FRA ? () => form.submit() : undefined}
    >
      <Typography>
        <Translation {...TXTCLI_Make_your_first_deposit_to_sta_ELL} />
      </Typography>
    </Prompt>
  );
};

ProceedToDeposit.displayName = 'ProceedToDeposit';

export default ProceedToDeposit;
